/* eslint-disable no-sparse-arrays */

export const sideBarMenu = [
    {
        id: 20,
        name: 'Dashboard',
        url: '/',
        active: '/images/Component1321.svg',
        inactive: '/images/manage_categories_default.svg',
        previlage: 'view_dashboard',

    },
    {
        id: 8,
        name: 'Manage Orders',
        url: '/manage-orders',
        active: '/images/boxes-active.svg',
        inactive: '/images/Manage-Orders-icon.svg',
        previlage: 'orders:list',

    },
    {
        id: 2,
        name: 'Pending Approvals',
        url: '/manage-pending-approvals',
        active: '/images/clock-seven-active.svg',
        inactive: '/images/Pending-Approvals-icon.svg',
        previlage: 'pending_approvals:manage_pending_view',

    },
    {
        id: 3,
        name: 'Cancelled Orders',
        url: '/cancelled-orders',
        active: '/images/rejected-active.svg',
        inactive: '/images/Rejected-Orders-Icon.svg',
        previlage: 'orders:list',

    },
    {
        id: 24,
        name: 'Invoices',
        url: '/invoices',
        active: '/images/admin-invoiceActive.svg',
        inactive: '/images/admin-invoiceDefault.svg',
        previlage: 'invoices:list',

    },
    {
        id: 25,
        name: 'Credit/Debit Details',
        url: '/credit-debit-details',
        active: '/images/credit-debit-active.svg',
        inactive: '/images/credit-debit-default.svg',
        previlage: 'credit_debit:list',

    },
    {
        id: 30,
        name: 'Transactions',
        url: '/transactions',
        active: '/images/transaction-active.svg',
        inactive: '/images/transaction-default.svg',
        previlage: 'transactions:list',

    },
    {
        id: 31,
        name: 'Return Requests',
        url: '/return-requests',
        active: '/images/manage_returnReq-Active.svg',
        inactive: '/images/manage_returnReq-Default.svg',
        previlage: 'invoices:list',

    },
    {
        id: 4,
        name: 'Trade & Commercial Policy/offers',
        url: '/manage-offers',
        active: '/images/TradeiconAtive.svg',
        inactive: '/images/tradedefault.svg',
        previlage: 'deals:list',

    },
    {
        id: 40,
        name: 'Bulk Offer',
        url: '/bulk-offers',
        active: '/images/bulk-offer-Active.svg',
        inactive: '/images/bulk_offer_icon_default.svg',
        previlage: 'deals:list',

    },
    {
        id: 5,
        name: 'Freight Policy (DAP)',
        url: '/manage-freight-policy',
        active: '/images/Component_130_1.svg',
        inactive: '/images/Component1303.svg',
        previlage: 'dap:list',
    },
    {
        id: 6,
        name: 'Ador Cash Management',
        url: '/ador-cash-management',
        active: '/images/Acashactive.svg',
        inactive: '/images/Acash.svg',
        previlage: 'cashback:list',
    },
    {
        id: 7,
        name: 'Promotion/ Campaign Banners',
        url: '/promotion',
        active: '/images/tagactive.svg',
        inactive: '/images/tag.svg',
        previlage: 'manage_banners',
    },
    {
        id: 1,
        name: 'Manage Internal Users',
        url: '/manage-internal-users',
        active: '/images/manage_internal_active.svg',
        inactive: '/images/Component13331.svg',
        previlage: 'admin_users:list',
    },
    {
        id: 9,
        name: 'Distributors/Customers',
        url: '/distributors',
        active: '/images/usersalt.svg',
        inactive: '/images/users.svg',
        previlage: 'distributor:list',
    },

    {
        id: 10,
        name: 'MIS Reports',
        url: 'mis-reports',
        active: '/images/document-active.svg',
        inactive: '/images/document.svg',
        previlage: 'mis_reports',
        tabs: [
            {
                id: 5,
                name: 'Indent Details',
                url: '/mis-reports/indent-report',
                active: '/images/document-active.svg',
                inactive: '/images/document.svg',
            },
            {
                id: 1,
                name: 'Pending Order Details',
                url: '/mis-reports/pending-order-statement-report',
                active: '/images/document-active.svg',
                inactive: '/images/document.svg',
            },
            {
                id: 6,
                name: 'Invoice Details',
                url: '/mis-reports/invoice-report',
                active: '/images/document-active.svg',
                inactive: '/images/document.svg',
            },
            {
                id: 3,
                name: 'Outstanding Invoice Details',
                url: '/mis-reports/outstanding-invoice-details-report',
                active: '/images/document-active.svg',
                inactive: '/images/document.svg',
            },
            {
                id: 2,
                name: 'Customer Wise Outstanding Details',
                url: '/mis-reports/customer-wise-outstanding-report',
                active: '/images/document-active.svg',
                inactive: '/images/document.svg',
            },
            {
                id: 4,
                name: 'Area Wise Customer Outstanding Details',
                url: '/mis-reports/area-wise-customer-outstanding-report',
                active: '/images/document-active.svg',
                inactive: '/images/document.svg',
            },
            // {
            //     id: 7,
            //     name: 'FG Stock Details',
            //     url: '/mis-reports/fg-stock-details',
            //     active: '/images/document-active.svg',
            //     inactive: '/images/document.svg',
            // },
        ],
    },
    {
        id: 11,
        name: 'Shipping Organization (3PL)',
        url: '/shipping-organization',
        active: '/images/ShippingOrganizationicon-active.svg',
        inactive: '/images/Shipping-Organization-icon.svg',
        previlage: 'view_3pls',
    },
    {
        id: 12,
        name: 'Categories and SKU’s',
        url: '/product-listing',
        active: '/images/Component1321.svg',
        inactive: '/images/manage_categories_default.svg',
        previlage: 'view_categories',
    },
    {
        id: 14,
        name: 'Stock',
        url: '/stock',
        active: '/images/Component13512.svg',
        inactive: '/images/stock.svg',
        previlage: 'stock_inventory',
    },
    {
        id: 15,
        name: 'Product Price List',
        url: '/product-list-price',
        active: '/images/list-active.svg',
        inactive: '/images/list.svg',
        previlage: 'price_list',
    },
    {
        id: 16,
        name: 'Resource',
        url: '/resource',
        active: '/images/package-active.svg',
        inactive: '/images/package.svg',
        previlage: 'manage_resources',
        subtabs: [
            {
                id: 1,
                name: 'Category Management',
                url: '/resource/category-management',
                active: '/images/package-active.svg',
                inactive: '/images/package.svg',
            },
            {
                id: 2,
                name: 'Resource Management',
                url: '/resource/resource-management',
                active: '/images/package-active.svg',
                inactive: '/images/package.svg',
            },
        ],
    },
    {
        id: 18,
        name: 'System Setup Menu',
        url: '/system-setup-menu',
        active: '/images/tool-active.svg',
        inactive: '/images/tool.svg',
        previlage: 'manage_settings',
    },
    {
        id: 19,
        name: 'IP-Based Order Report',
        url: '/ip-order-report',
        active: '/images/document-active.svg',
        inactive: '/images/document.svg',
        previlage: 'ip_order_report',
    },
];
export const baseURL = process.env.REACT_APP_BASE_URL || 'https://apis.ador.co/dev/v1';
export const AccessPrevileges = {
    view_dashboard: {
        id: 'v1',
        label: 'View Dashboard',
        value: 'view_dashboard',
    },
    manage_admin_users: [{
        id: 'ma-1',
        label: 'create admin user',
        value: 'admin_users:create',
    }, {
        id: 'ma-2',
        label: 'list and view admin user',
        value: 'admin_users:list',
    }, {
        id: 'ma-3',
        label: 'update admin user',
        value: 'admin_users:update',
    },
    {
        id: 'ma-4',
        label: 'activate admin user',
        value: 'admin_users:activate',
    },
    {
        id: 'ma-5',
        label: 'deactivate admin user',
        value: 'admin_users:deactivate',
    },
    {
        id: 'ma-6',
        label: 'reset password',
        value: 'admin_users:reset_password',
    }],
    manage_distributor: [
        {
            id: 'mdc-1',
            label: 'View Distributors/ Customer',
            value: 'distributor:view',
        },
        {
            id: 'mdc-2',
            label: 'Update Addresses and 3PLs',
            value: 'distributor:update',
        },
        {
            id: 'mdc-3',
            label: 'Assignment of ASE, ASM, Product Category',
            value: 'distributor:assignment',
        },
        {
            id: 'mdc-4',
            label: 'Upload Certificate',
            value: 'distributor:upload_certificate',
        },
        {
            id: 'mdc-5',
            label: 'List Distributor',
            value: 'distributor:list',
        },
    ],
    view_3pls: {
        id: 'v3pl',
        label: 'View 3PLs',
        value: 'view_3pls',
    },
    view_categories: {
        id: 'v',
        label: 'View Categories & SKU"s',
        value: 'view_categories',
    },
    manage_deals: [{
        id: 'md-1',
        label: 'View Offers',
        value: 'deals:view',
    }, {
        id: 'md-3',
        label: 'Create New Offer',
        value: 'deals:create',
    },
    {
        id: 'md-4',
        label: 'Update Offer',
        value: 'deals:update',
    },
    {
        id: 'md-5',
        label: 'Activate Offer',
        value: 'deals:activate',
    },
    {
        id: 'md-6',
        label: 'Deactivate Offer',
        value: 'deals:deactivate',
    },
    {
        id: 'md-7',
        label: 'List Offer',
        value: 'deals:list',
    },
    ],
    manage_DAP: [{
        id: 'dap-5',
        label: 'View DAP Policy',
        value: 'dap:view',
    }, {
        id: 'dap-1',
        label: 'Create New DAP policy',
        value: 'dap:create',
    }, {
        id: 'dap-2',
        label: 'Update DAP Policy',
        value: 'dap:update',
    }, {
        id: 'dap-3',
        label: 'Activate DAP Policy',
        value: 'dap:activate',
    },
    {
        id: 'dap-4',
        label: 'Deactivate DAP Policy',
        value: 'dap:deactivate',
    },
    {
        id: 'dap-6',
        label: 'List DAP Policy',
        value: 'dap:list',
    }],
    manage_orders: [{
        id: 'mo-1',
        label: 'Create Distributor Order(Trade, Trade EUB)',
        value: 'orders:create_distributor_trade_order',
    },
    {
        id: 'mo-3',
        label: 'Create Orders (Direct- Demo, Free sample, Service Parts)',
        value: 'orders:create_direct_order',
    },
    {
        id: 'mo-4',
        label: 'List Orders',
        value: 'orders:list',
    },
    {
        id: 'mo-5',
        label: 'View Orders',
        value: 'orders:view',
    }, {
        id: 'mo-6',
        label: 'Approve Order',
        value: 'orders:approve',
    }, {
        id: 'mo-7',
        label: 'Cancel Order',
        value: 'orders:cancel',
    },
    {
        id: 'mo-8',
        label: 'Update Orders',
        value: 'orders:update',
    },
    {
        id: 'mo-9',
        label: 'Transfer Orders',
        value: 'orders:transfer',
    },
    ],
    pending_approvals: [{
        id: 'Pa-1',
        label: 'manage pending approvals',
        value: 'pending_approvals:manage_pending_approvals',
    },
    {
        id: 'Pa-2',
        label: 'view pending approvals',
        value: 'pending_approvals:manage_pending_view',
    },
    ],
    manage_invoices: [{
        id: 'mi-1',
        label: 'List Invoices (LR, Test Certificate, E-way Bill, e-Invoice)',
        value: 'invoices:list',
    },
    {
        id: 'mi-2',
        label: 'Upload Documents in Invoices (LR,Test Certificate, E-way Bill, e-Invoice)',
        value: 'invoices:upload',
    }, {
        id: 'mi-3',
        label: 'Accept or Reject Return Request',
        value: 'invoices:accept_or_reject_return_request',
    },
    {
        id: 'mi-4',
        label: 'Option to Update Payment Not',
        value: 'invoices:update_payment',
    }],
    credit_debit_details: {
        id: 'cd-1',
        label: 'Credit/Debit Details',
        value: 'credit_debit:list',
    },
    mis_reports: {
        id: 'misr-1',
        label: 'MIS Reports',
        value: 'mis_reports',
    },
    manage_resources: {
        id: 'mr-1',
        label: 'Manage Resources',
        value: 'manage_resources',
    },
    manage_settings: {
        id: 'mst-1',
        label: 'Manage Settings',
        value: 'manage_settings',
    },
    manage_banners: {
        id: 'mb-1',
        label: 'Manage Banners',
        value: 'manage_banners',
    },
    manage_transactions: [
        {
            id: 'mt-1',
            label: 'list transactions',
            value: 'transactions:list',
        }, {
            id: 'mt-2',
            label: 'edit transactions',
            value: 'transactions:update',
        },
    ],
    manage_cashback_transactions: [{
        id: 'mct-1',
        label: 'view cashback transactions',
        value: 'cashback:view',
    }, {
        id: 'mct-2',
        label: 'adjust cashback',
        value: 'cashback:adjust',
    }, {
        id: 'mct-3',
        label: 'list cashback',
        value: 'cashback:list',
    }],
    price_list: {
        id: 'pricev1',
        label: 'Price List',
        value: 'price_list',
    },
    bulk_offer: {
        id: 'bulk1',
        label: 'Bulk Offer',
        value: 'bulk_offer',
    },
    stock_inventory: {
        id: 'stock-1',
        label: 'Stock Inventory',
        value: 'stock_inventory',
    },
    ip_order_report: {
        id: 'ip-1',
        label: 'IP-Based Order Report',
        value: 'ip_order_report',
    },
    categories: [{
        id: 'category-1',
        label: 'Add Category',
        value: 'categories:add',
    },
    {
        id: 'category-2',
        label: 'Edit Category',
        value: 'categories:edit',
    },
    {
        id: 'category-3',
        label: 'Activate Category',
        value: 'categories:activate',
    }, {
        id: 'category-4',
        label: 'Deactivate Category',
        value: 'categories:deactivate',
    }],
    products: [{
        id: 'peoduct-1',
        label: 'Add Product',
        value: 'product:add',
    },
    {
        id: 'peoduct-2',
        label: 'Edit Product',
        value: 'product:edit',
    },
    {
        id: 'peoduct-3',
        label: 'Edit Product',
        value: 'product:list',
    },
    {
        id: 'peoduct-4',
        label: 'Activate Product',
        value: 'product:activate',
    }, {
        id: 'peoduct-5',
        label: 'Deactivate Product',
        value: 'product:deactivate',
    }],
};

/**
 * Default access privileges to auto-select when a role is chosen while creating/updating
 * an internal admin user. Keyed by ROLE_CODE (from the roles list API), each entry is an
 * array of privilege `value` strings that map to entries inside AccessPrevileges.
 */
export const RoleAccessPrivilegeMap = {
    // Area Sales Engineer
    ASE: [
        'view_dashboard',
        'invoices:list',
        'price_list',
        'view_categories',
        'orders:create_direct_order',
        'orders:list',
        'orders:view',
        'orders:update',
        'mis_reports',
        'stock_inventory',
        'credit_debit:list',
        'distributor:view',
        'distributor:list',
        'pending_approvals:manage_pending_approvals',
        'pending_approvals:manage_pending_view',
    ],
    // Regional Sales Manager
    RSM: [
        'view_dashboard',
        'invoices:list',
        'price_list',
        'view_categories',
        'orders:list',
        'orders:view',
        'orders:approve',
        'orders:cancel',
        'orders:update',
        'mis_reports',
        'credit_debit:list',
        'distributor:view',
        'distributor:list',
        'pending_approvals:manage_pending_approvals',
        'pending_approvals:manage_pending_view',
    ],
    // Customer Care Centre HEAD
    CCCH: [
        'view_dashboard',
        'invoices:list',
        'price_list',
        'view_categories',
        'orders:create_distributor_trade_order',
        'orders:create_direct_order',
        'orders:list',
        'orders:view',
        'orders:approve',
        'orders:cancel',
        'orders:update',
        'mis_reports',
        'stock_inventory',
        'credit_debit:list',
        'distributor:view',
        'distributor:list',
        'pending_approvals:manage_pending_approvals',
        'pending_approvals:manage_pending_view',
        'cashback:view',
        'cashback:list',
    ],
    // Plant Quality Head Raipur
    PQHR: [
        'view_dashboard',
        'view_3pls',
        'invoices:list',
        'view_categories',
        'orders:create_distributor_trade_order',
        'orders:create_direct_order',
        'orders:list',
        'orders:view',
        'orders:approve',
        'orders:cancel',
        'orders:update',
        'mis_reports',
        'stock_inventory',
        'credit_debit:list',
        'distributor:view',
        'distributor:list',
        'pending_approvals:manage_pending_approvals',
        'pending_approvals:manage_pending_view',
        'cashback:view',
        'cashback:list',
    ],
    // Area Sales Manager
    ASM: [
        'view_dashboard',
        'invoices:list',
        'price_list',
        'view_categories',
        'orders:create_direct_order',
        'orders:list',
        'orders:view',
        'orders:approve',
        'orders:cancel',
        'orders:update',
        'mis_reports',
        'stock_inventory',
        'credit_debit:list',
        'distributor:view',
        'distributor:list',
        'pending_approvals:manage_pending_approvals',
        'pending_approvals:manage_pending_view',
    ],
    // Sales Head
    SH: [
        'view_dashboard',
        'dap:view',
        'dap:list',
        'invoices:list',
        'invoices:accept_or_reject_return_request',
        'price_list',
        'view_categories',
        'orders:create_distributor_trade_order',
        'orders:create_direct_order',
        'orders:list',
        'orders:view',
        'orders:approve',
        'orders:cancel',
        'orders:update',
        'mis_reports',
        'stock_inventory',
        'credit_debit:list',
        'distributor:view',
        'distributor:list',
        'deals:view',
        'deals:list',
        'manage_resources',
        'pending_approvals:manage_pending_approvals',
        'pending_approvals:manage_pending_view',
        'cashback:view',
        'cashback:list',
    ],
    // admin
    ADM: [
        'view_dashboard',
        'view_3pls',
        'dap:view',
        'dap:create',
        'dap:update',
        'dap:activate',
        'dap:deactivate',
        'dap:list',
        'manage_settings',
        'invoices:list',
        'price_list',
        'admin_users:create',
        'admin_users:list',
        'admin_users:update',
        'admin_users:activate',
        'admin_users:deactivate',
        'admin_users:reset_password',
        'transactions:list',
        'transactions:update',
        'view_categories',
        'orders:list',
        'mis_reports',
        'manage_banners',
        'stock_inventory',
        'credit_debit:list',
        'distributor:view',
        'distributor:update',
        'distributor:assignment',
        'distributor:upload_certificate',
        'distributor:list',
        // Trade & Commercial policy offers - all excluding Activate Offer
        'deals:view',
        'deals:create',
        'deals:update',
        'deals:deactivate',
        'deals:list',
        'manage_resources',
        'pending_approvals:manage_pending_approvals',
        'pending_approvals:manage_pending_view',
        // Ador Cash - all
        'cashback:view',
        'cashback:adjust',
        'cashback:list',
    ],
    // COSTING
    CT: [
        'view_dashboard',
        'view_3pls',
        'invoices:list',
        'view_categories',
        'orders:create_distributor_trade_order',
        'orders:create_direct_order',
        'orders:list',
        'orders:view',
        'orders:approve',
        'orders:cancel',
        'orders:update',
        'stock_inventory',
        'credit_debit:list',
        'distributor:view',
        'distributor:list',
        'deals:view',
        'deals:list',
        'pending_approvals:manage_pending_approvals',
        'pending_approvals:manage_pending_view',
        'cashback:view',
        'cashback:list',
    ],
    // TDC
    TDC: [
        'view_dashboard',
        'invoices:list',
        'view_categories',
        'orders:create_distributor_trade_order',
        'orders:create_direct_order',
        'orders:list',
        'orders:view',
        'orders:approve',
        'orders:cancel',
        'orders:update',
        'mis_reports',
        'stock_inventory',
        'credit_debit:list',
        'distributor:view',
        'distributor:list',
        'pending_approvals:manage_pending_approvals',
        'pending_approvals:manage_pending_view',
        'cashback:view',
        'cashback:list',
    ],
    // TECHNICAL HEAD
    TH: [
        'view_dashboard',
        'view_3pls',
        'invoices:list',
        'price_list',
        'view_categories',
        'orders:create_distributor_trade_order',
        'orders:create_direct_order',
        'orders:list',
        'orders:view',
        'orders:approve',
        'orders:cancel',
        'orders:update',
        'credit_debit:list',
        'distributor:view',
        'pending_approvals:manage_pending_approvals',
        'pending_approvals:manage_pending_view',
        'cashback:view',
        'cashback:list',
    ],
    // COPEC
    COPEC: [
        'view_dashboard',
        'dap:view',
        'dap:list',
        // Invoice - All
        'invoices:list',
        'invoices:upload',
        'invoices:accept_or_reject_return_request',
        'invoices:update_payment',
        'price_list',
        'view_categories',
        'orders:create_distributor_trade_order',
        'orders:create_direct_order',
        'orders:list',
        'orders:view',
        'orders:approve',
        'orders:cancel',
        'orders:update',
        'mis_reports',
        'stock_inventory',
        'credit_debit:list',
        'distributor:view',
        'distributor:list',
        'pending_approvals:manage_pending_approvals',
        'pending_approvals:manage_pending_view',
        'cashback:view',
        'cashback:list',
    ],
    // Accountant
    FN: [
        'view_dashboard',
        'view_3pls',
        'invoices:list',
        'view_categories',
        'orders:create_distributor_trade_order',
        'orders:create_direct_order',
        'orders:list',
        'orders:view',
        'orders:approve',
        'orders:cancel',
        'orders:update',
        'mis_reports',
        'stock_inventory',
        'credit_debit:list',
        'distributor:view',
        'distributor:list',
        'deals:view',
        'deals:list',
        'pending_approvals:manage_pending_approvals',
        'pending_approvals:manage_pending_view',
        'cashback:view',
        'cashback:list',
    ],
    // Viewer
    VIEW: [
        'view_dashboard',
        'view_3pls',
        'invoices:list',
        'price_list',
        'view_categories',
        'orders:create_distributor_trade_order',
        'orders:create_direct_order',
        'orders:list',
        'orders:view',
        'orders:approve',
        'orders:cancel',
        'orders:update',
        'credit_debit:list',
        'distributor:view',
        'pending_approvals:manage_pending_approvals',
        'pending_approvals:manage_pending_view',
        'cashback:view',
        'cashback:list',
    ],
};

export const territaryList = [{
    id: 1,
    label: 'territory1',
}, {
    id: 2,
    label: 'south east',
}, {
    id: 1,
    label: 'territory2',
}, {
    id: 1,
    label: 'south west',
}];

export const Roles = [{
    id: 1,
    label: 'Area Sales Engineer',
}, {
    id: 2,
    label: 'Service Engineer',
}, {
    id: 3,
    label: 'Area Sales Manager',
}, {
    id: 4,
    label: 'Regional Business Manager',
},
{
    id: 5,
    label: 'Business Head',
}, {
    id: 6,
    label: 'Customer Support Desk',
}, {
    id: 7,
    label: 'Central Marketing Office',
}, {
    id: 8,
    label: 'Product Development Consumables',
},,
    {
        id: 9,
        label: 'Service Engineer',
    },
    {
        id: 10,
        label: 'Product Development Equipment',
    },
    {
        id: 11,
        label: 'Marketing Dept',
    }, {
        id: 12,
        label: 'Costing Dept',
    }, {
        id: 13,
        label: 'Account Dept',
    }, {
        id: 14,
        label: 'Auditors',
    }, {
        id: 15,
        label: 'Super User',
    }, {
        id: 16,
        label: 'Quality',
    },, {
        id: 17,
        label: 'Product Management',
    }, {
        id: 18,
        label: 'Customer Care',
    }, {
        id: 19,
        label: 'Technical marketing',
    }, {
        id: 20,
        label: 'Production',
    }];

export const constantManagers = [{
    id: 1,
    label: 'John Doe',
}, {
    id: 2,
    label: 'Kate Hudson',
}, {
    id: 3,
    label: 'Dylan OBrien',
}];
export const threePL = [{
    id: 1,
    label: 'pune plant1',
}, {
    id: 2,
    label: 'pune plant2',
}, {
    id: 3,
    label: 'pune plant3',
},
{
    id: 4,
    label: 'pune plant4',
}];

export const Products = [{
    id: 1,
    label: 'Consumables',
}, {
    id: 2,
    label: 'Equipments',
}, {
    id: 3,
    label: 'Others',
}];

/**
 * Privileges with a single value for the whole distributor (no per-category split).
 */
export const GlobalDistributorPrevileges = [
    'stock_visibility',
    'resources_visibility',
    'ador_cash_ledger',
    'manage_assistant_user',
    'raise_ticket',
    'ador_cash_credit',
    'ador_cash_debit',
    'credit_limit',
    'credit_debit:list',
];

/**
 * Privileges that can be enabled/disabled independently per product category (IWB/MnR).
 */
export const CategoryDistributorPrevileges = [
    'bulk_deal_visibility',
    'return_order',
    'place_trade_order',
    'place_eub_order',
    'price_list_visibility',
    'cash_discount',
];

/**
 * Distributor PRODUCT_CATEGORIES entries are dot-path segments rooted at one of these
 * top-level values (e.g. "EQUIPMENT.Hardfacing"). Used to determine which category tab
 * columns are applicable for a given distributor, mirroring the IWB/MnR grouping used
 * elsewhere in the backend (bulk-offers category validation).
 */
export const DistributorPrivilegeCategoryPrefixes = {
    IWB: ['CONSUMABLES', 'EQUIPMENT', 'OTHERS'],
    MnR: ['MnR'],
};
export const exceptThisSymbols = ['e', 'E', '+', '-', '.'];
export const CDN = process.env.REACT_APP_CDN;
